import { render, staticRenderFns } from "./EditLog.vue?vue&type=template&id=12f9f7b4&scoped=true"
import script from "./EditLog.vue?vue&type=script&lang=js"
export * from "./EditLog.vue?vue&type=script&lang=js"
import style0 from "./EditLog.vue?vue&type=style&index=0&id=12f9f7b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9f7b4",
  null
  
)

export default component.exports